export enum SlotStateError {
	BAD_REQUEST = 'badRequest',
	REQUEST_FAILURE = 'requestFailure',
	NODE_NOT_FOUND = 'nodeNotFound'
}
